import { render, staticRenderFns } from "./DutySelector.vue?vue&type=template&id=6c709356&"
import script from "./DutySelector.vue?vue&type=script&lang=js&"
export * from "./DutySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports